







































import { listFactory } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';

import { apiProvider } from '@/modules/sklad/ndCenik/api';

import { validateFiletype } from '@/main/utils/fileHelper';

import { store } from './store/list';
import { BULK_PARTS_UPLOAD, FILE_TYPE, MAX_SIZE, NAME } from './constants';

export default listFactory(NAME, store).extend({
	data() {
		return {
			isSubmitting: false,
			showDateFilter: false,
			notificationDialog: {
				visible: false,
				notificationDialogMsg: this.LocalizePopisostatni('requisitionForm'),
				handleClose: () => {},
			},
			showDialog: {
				visible: false,
				title: null as string | null,
				extraButtons: null as object | null,
				handleClose: () => {},
			},
			fileList: [] as any[],
			UploadAll: false,
		};
	},
	computed: {
		isUploadAllDisabled() {
			return this.ProvozovnaId !== null || this.SkladOzn !== null;
		},
	},
	methods: {
		dealerLocationUpdate() {
			const result = {} as any;
			this.dropdownList.ProvozovnaId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},
		wareHouseUpdate() {
			const result = {} as any;
			this.dropdownList.SkladOzn.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},
		validateAndSubmit() {
			if (this.validateFields()) {
				this.submitUpload();
			}
		},
		validateFields() {
			if (this.fileList.length === 0) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('UploadFile'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			if (!this.UploadAll && !this.ProvozovnaId) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('WorkShopNotBeNull'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			if (!this.UploadAll && !this.SkladOzn) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('WareHouseNotBeNull'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		async onWorkShopChange(workshopId: any) {
			if (workshopId !== undefined || workshopId !== null) {
				this.filter.SkladOzn = null;
				const { data } = await apiProvider.GetWarehouse(workshopId);
				this.dropdownList.SkladOzn = data;
			}
		},
		async submitUpload() {
			const StartTime = performance.now();
			if (!this.validateFields()) {
				return;
			}
			const isFileValid	= this.fileList[0].name.split('.').pop() !== FILE_TYPE;
			if (isFileValid) {
				showAlert({
					message: this.LocalizeChyboveHlasky('InvalidFileType'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.isSubmitting = true;
			this.startLoading();
			try {
				this.ProvozovnaId = this.UploadAll ? -1 : this.ProvozovnaId;
				this.SkladOzn = this.UploadAll ? -1 : this.SkladOzn;
				const { data: partsInfo } = await apiProvider.uploadParts(this.fileList[0], this.UploadAll, this.ProvozovnaId, this.SkladOzn);
				this.fileList = [];
				if (partsInfo) {
					showAlert({
						message: partsInfo,
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				}
				this.showDialog.visible = false;
				await this.tableData();
				this.endLoading();
			} catch (error) {
				this.endLoading();
				this.isSubmitting = false;
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
			let iTotalTimeTaken = performance.now() - StartTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('PartsPrp', 'CDB to Dealer', BULK_PARTS_UPLOAD, seconds);
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		createClick() {
			this.showDialog.visible = true;
		},
		handleUploadAllChange() {
			this.UploadAll = !this.UploadAll;
			if (this.UploadAll) {
				this.ProvozovnaId = null;
				this.SkladOzn = null;
			}
		},
		handleDropdownChange() {
			this.UploadAll = false;
		},
	},
});
